import { useState } from "react";
import { motion } from "framer-motion";
import { Lightbox } from "./Lightbox";

export const GalleryGrid = ({ items, categories }) => {
  const [filter, setFilter] = useState("All");
  const [active, setActive] = useState(null);

  const visible =
    filter === "All" ? items : items.filter((g) => g.category === filter);

  return (
    <div>
      {categories && (
        <div
          className="no-scrollbar mb-8 flex gap-2 overflow-x-auto pb-1"
          role="tablist"
          aria-label="Gallery filters"
        >
          {categories.map((c) => (
            <button
              key={c}
              role="tab"
              aria-selected={filter === c}
              onClick={() => setFilter(c)}
              data-testid={`gallery-filter-${c.toLowerCase().replace(/\s/g, "-")}`}
              className={`shrink-0 rounded-full border px-5 py-2 text-[11px] font-bold uppercase tracking-[0.2em] transition-colors duration-300 ${
                filter === c
                  ? "border-hotpink bg-hotpink text-white"
                  : "border-white/15 text-white/60 hover:border-white/40 hover:text-white"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
      )}

      <div className="columns-2 gap-3 md:columns-3 md:gap-4">
        {visible.map((g, i) => (
          <motion.figure
            key={g.id}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.55, delay: (i % 3) * 0.08 }}
            className="group relative mb-3 break-inside-avoid overflow-hidden rounded-2xl border border-white/10 md:mb-4"
          >
            <button
              type="button"
              onClick={() => setActive(g)}
              className="block w-full"
              aria-label={`Open ${g.style} photo`}
              data-testid={`gallery-item-${g.id}`}
            >
              <img
                src={g.src}
                alt={g.alt}
                loading="lazy"
                className="w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <span className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
              <span className="absolute bottom-0 left-0 w-full translate-y-2 p-4 text-left opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100">
                <span className="block font-serif text-base">{g.style}</span>
                <span className="text-[10px] uppercase tracking-[0.25em] text-hotpink">
                  {g.category}
                </span>
              </span>
            </button>
          </motion.figure>
        ))}
      </div>

      <Lightbox item={active} onClose={() => setActive(null)} />
    </div>
  );
};

